"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderBreadcrumbButton_unstable", {
    enumerable: true,
    get: function() {
        return renderBreadcrumbButton_unstable;
    }
});
const _reactbutton = require("@fluentui/react-button");
const renderBreadcrumbButton_unstable = (state)=>{
    return (0, _reactbutton.renderButton_unstable)(state);
};
